import { useCallback, useMemo, useState } from "react";
import { ModalProps } from "..";

export interface UseModalStateOptions {
  enableClickOutside?: boolean;
  disableClose?: boolean;
}

export const useModalState = (options?: UseModalStateOptions) => {
  const [open, setOpen] = useState(false);
  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);
  const handlers: Pick<ModalProps, "onClose" | "onClickOutside"> =
    useMemo(() => {
      return {
        onClose: options?.disableClose ? undefined : handleClose,
        onClickOutside: options?.enableClickOutside ? handleClose : undefined,
      };
    }, [handleClose, options]);
  return [
    {
      open,
      ...handlers,
    },
    handleOpen,
    handleClose,
    open,
  ] as const;
};
